// Libraries
import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
// Styles
import './Remembrance.scss';
// Models
import { IRemembranceProps } from './models/Remembrance';
// Constants
import { DAYS_COUNTER, FIRST_DAY, PLAN_EXPIRED, PLAN_TYPE } from './constants/Remembrance';

export const Remembrance: React.FC<IRemembranceProps> = ({ actualPlan, isFreeDemoActive }) => {
    const remaingPlanDays = actualPlan
        ? moment(actualPlan.finish_date).startOf('day').diff(moment().startOf('day'), 'days')
        : PLAN_EXPIRED;
    const daysCounterText = DAYS_COUNTER[remaingPlanDays];
    const actualPlanPeriodicity = actualPlan ? actualPlan.total_months : 1;
    return (
        <section className={`main`}>
            <p className="main__description">
                {remaingPlanDays < 0 && (
                    <>
                        Tu plan {PLAN_TYPE[actualPlan?.total_months || 1]} se ha vencido, para poder seguir haciendo uso de todas
                        las funcionalidades de nuestra plataforma es necesario adquirir uno nuevo
                        <Link className="button-remembrance" to="/subscription">
                            Adquirir plan
                        </Link>
                    </>
                )}
                {remaingPlanDays >= 0 && isFreeDemoActive && (
                    <>
                        <>
                            {' '}
                            ¡Tu periodo de prueba está por finalizar! No pierdas acceso a todas las herramientas que simplifican
                            la gestión de tu nómina y seguridad social. Haz clic en{' '}
                            <Link className="button-buy" to="/subscription">
                                Compra aquí
                            </Link>{' '}
                            y selecciona el plan que mejor se ajuste a tu empresa para continuar disfrutando de una experiencia
                            sin límites.
                        </>
                    </>
                )}
                {remaingPlanDays >= 0 && !isFreeDemoActive && (
                    <>
                        <>
                            En {`${daysCounterText} ${remaingPlanDays === FIRST_DAY ? 'día' : 'días'}`} finalizará tu plan{' '}
                            {PLAN_TYPE[actualPlanPeriodicity]}. Recuerda hacer el pago del plan de tu preferencia nuevamente, para
                            poder seguir haciendo uso de todas las funcionalidades de la plataforma.
                        </>
                    </>
                )}
            </p>
        </section>
    );
};
